module.exports = __webpack_public_path__ + "advisory-8c397925/anschreiben-aufbau-93d9c9007d593377289be25593fdf4fd.jpeg";